module.exports = __webpack_public_path__ + "static/modal_idcard_back.51087b34.png";